import React, { useEffect, useRef } from 'react';
import SafeIcon from '../common/SafeIcon';

const ProductLightbox = ({ images, activeIndex, onChange, onClose }) => {
  const closeButtonRef = useRef(null);

  useEffect(() => {
    closeButtonRef.current?.focus();

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onClose();
      if (event.key === 'ArrowLeft') onChange((activeIndex - 1 + images.length) % images.length);
      if (event.key === 'ArrowRight') onChange((activeIndex + 1) % images.length);
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [activeIndex, images.length, onChange, onClose]);

  const previousImage = (event) => {
    event.stopPropagation();
    onChange((activeIndex - 1 + images.length) % images.length);
  };

  const nextImage = (event) => {
    event.stopPropagation();
    onChange((activeIndex + 1) % images.length);
  };

  return (
    <div
      className="fixed inset-0 z-[100] bg-black/95 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-label="Náhled produktu"
      onClick={onClose}
    >
      <button
        ref={closeButtonRef}
        type="button"
        onClick={onClose}
        className="absolute top-5 right-5 z-10 p-3 text-white bg-white/10 rounded-full hover:bg-white/20 transition-colors"
        aria-label="Zavřít náhled"
      >
        <SafeIcon name="X" className="w-6 h-6" />
      </button>

      {images.length > 1 && (
        <>
          <button
            type="button"
            onClick={previousImage}
            className="absolute left-4 md:left-8 z-10 p-3 text-white bg-white/10 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Předchozí obrázek"
          >
            <SafeIcon name="ChevronLeft" className="w-7 h-7" />
          </button>
          <button
            type="button"
            onClick={nextImage}
            className="absolute right-4 md:right-8 z-10 p-3 text-white bg-white/10 rounded-full hover:bg-white/20 transition-colors"
            aria-label="Další obrázek"
          >
            <SafeIcon name="ChevronRight" className="w-7 h-7" />
          </button>
        </>
      )}

      <img
        src={images[activeIndex]}
        alt={`Produkt – obrázek ${activeIndex + 1}`}
        className="max-w-full max-h-full w-auto h-auto object-contain"
        onClick={(event) => event.stopPropagation()}
      />
    </div>
  );
};

export default ProductLightbox;